"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var DeliveryStyle = /** @class */ (function (_super) {
    __extends(DeliveryStyle, _super);
    function DeliveryStyle(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            value: state.data.delivery_style,
            error: state.error.delivery_style
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            state = form_store_1.default.getState();
            if (_this._isMounted) {
                _this.setState({
                    value: state.data.delivery_style,
                    error: state.error.delivery_style
                });
            }
        });
        return _this;
    }
    DeliveryStyle.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    DeliveryStyle.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    DeliveryStyle.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error, errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("ul", { className: "input-list input-list--vertical" },
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-radio" },
                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "delivery_style", value: "1", checked: parseInt(value) === 1, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u7D4C\u81A3\u5206\u5A29"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-radio" },
                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "delivery_style", value: "2", checked: parseInt(value) === 2, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u5E1D\u738B\u5207\u958B"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-radio" },
                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "delivery_style", value: "3", checked: parseInt(value) === 3, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u7D4C\u81A3\u53CA\u3073\u5E1D\u738B\u5207\u958B"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-radio" },
                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "delivery_style", value: "4", checked: parseInt(value) === 4, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u4E0D\u660E"))))));
    };
    return DeliveryStyle;
}(react_1.Component));
exports.default = DeliveryStyle;
